<template>
  <div>
    <board-view :detail="detail"></board-view>
  </div>
</template>

<script>
import BoardView from "@/pages/components/BoardView.vue";

export default {
  mixins: [],
  name: "CareerDetail",
  components: {
    BoardView
  },
  props: {},
  data() {
    return {
      detail: {}
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    this.recruitNo = this.$route.params.recruitNo;
    this.axios.post("/career/detail", { recruitNo: this.recruitNo }).then((result) => {
      this.detail = result.data;
    });
  }
};
</script>
